import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import Typography from "@mui/material/Typography";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

// function CloseIcon() {
//     return null;
// }

const BootstrapDialogTitle = () => {
    //const { children, onClose, ...other } = props;

    // return (
    //     <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
    //         {children}
    //         {onClose ? (
    //             <IconButton
    //                 aria-label="close"
    //                 onClick={onClose}
    //                 sx={{
    //                     position: 'absolute',
    //                     right: 8,
    //                     top: 8,
    //                     color: (theme) => theme.palette.grey[500],
    //                 }}
    //             >
    //                 <CloseIcon />
    //             </IconButton>
    //         ) : null}
    //     </DialogTitle>
    // );
    return (
        <Box sx={{ flexGrow: 1 }}>

        </Box>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

export default function CustomizedDialogs() {
    const [open, setOpen] = React.useState(true);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose} dir="rtl">
                    <Typography id="modal-modal-title" variant="h4" component="div" >
                        مقدمه
                    </Typography>
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <Box dir="rtl">
                        <Typography id="modal-modal-description" sx={{ mt: 2 }} gutterBottom={true}>
                            این نرم افزار با هدف تشخیص و مدیریت صحیح درمان دیس لیپیدمی به منظور دسترسی راحت برای کادر درمان طراحی شده است.
                            <br />
                            از آن‌جایی که بیماری های قلبی عروقی از شایع‌ترین علل مرگ و میر قابل پیشگیری هستند ،درمان صحیح دیس لیپیدمی اهمیت بسیاری دارد.
                            <br />
                            درمان غیردارویی همزمان با درمان دارویی درتمام بیماران توصیه می‌شود.
                            <br />
                            <b>
                                درمان های غیر دارویی
                            </b>
                            <br />
                            •	تعدیل سبک زندگی (رژیم غذایی، کاهش وزن، فعالیت فیزیکی و ترک سیگار و الکل) برای عموم افراد، افراد در خطر بالای ASCVD و افراد مبتلا به ASCVD بالینی توصیه می گردد.
                            <br />
                            •	رژیم غذایی
                            <br />
                            •	از یک الگوی غذایی غنی از میوه جات، سبزیجات، غلات کامل، لبنیات کم چرب، طیور کم چرب، ماهی، حبوبات، روغن های گیاهی و آجیل پیروی شود.
                            <br />
                            •	مصرف شیرینی ها، نوشیدنی های حاوی شکر و گوشت قرمز محدود گردد.
                            <br />
                            •	دریافت کالری باید به گونه ای تنظیم شود که از افزایش وزن اجتناب شده و کاهش وزن تقویت شود.
                            <br />
                            •	فعالیت فیزیکی
                            <br />
                            •	فعالیت بدنی هوازی با قدرت متوسط تا شدید 4-3 بار در هفته با میانگین 40 دقیقه در هر جلسه توصیه می گردد.
                            <br />
                            • ترک سیگار
                            <br />
                            • عدم مصرف الکل

                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleClose}>
                        close
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}
